import { configureStore } from '@reduxjs/toolkit';
import notificationReducer from './slices/notificationSlice';

const store = configureStore({
  reducer: {
    notifications: notificationReducer,
    // Add other reducers here as the app grows
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Useful if we have complex payloads from Firebase
    }),
});

export default store;
